import { render, staticRenderFns } from "./ContractAnswer.vue?vue&type=template&id=2b8d8f5d&scoped=true&"
import script from "./ContractAnswer.vue?vue&type=script&lang=js&"
export * from "./ContractAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ContractAnswer.vue?vue&type=style&index=0&id=2b8d8f5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d8f5d",
  null
  
)

export default component.exports